<template>
    <div class="verified-datepicker" :class="{ 'height-form': inForm }">
        <VerifiedLable
            :id="id"
            :title="title"
            :tagnewid="tagnewid"
            :required="required"
            :disableMLtitle="disableMLtitle"
            :tooltipLabel="tooltipLabel"
            :tooltipPosition="tooltipPosition"
            :tooltipType="tooltipType"
            :tooltipSize="tooltipSize"
            :tooltipMultilined="tooltipMultilined"
        />

        <b-field grouped>
            <a
                v-if="innerHideInfo"
                class="button button-show-hide"
                :class="{
                    'invalid-button-before': focusedOut && invalid && innerInvalidWhenDisabled,
                }"
                @click="innerInfoIsHidden = !innerInfoIsHidden"
            >
                <b-icon v-if="!innerInfoIsHidden" icon="eye-off-outline" type="is-danger" />
                <b-icon v-if="innerInfoIsHidden" icon="eye-outline" type="is-success" />
            </a>
            <b-input
                ref="dateInput"
                expanded
                :type="innerType"
                :value="inputDate"
                @change="updateDataInput($event)"
                @input="updateDataInput($event)"
                class="datapicker-input"
                :placeholder="
                    disableMLplaceholder
                        ? placeholder
                        : getT(placeholder, '')
                "
                v-mask="['##/##/####']"
                :disabled="disabled"
                :class="{
                    invalid: invalid && required && focusedOut && innerInvalidWhenDisabled,
                    'input-hide': innerHideInfo,
                    'hidden-field': hideInfo && innerInfoIsHidden
                }"
                @blur="blurEvt()"
                @focus="focusEvt()"
            />
            <b-datepicker
                class="date-block datapiker-button"
                v-model="innerDate"
                :mobile-native="false"
                :years-range="yearsRange"
                :day-names="dayNames"
                :month-names="monthNames"
                @input="updateData"
                :min-date="
                    dateType == 'endDate' && startDate != null
                        ? parseDate(startDate)
                        : parseDate(minDate)
                "
                :max-date="
                    dateType == 'startDate' && endDate != null
                        ? parseDate(endDate)
                        : dateType == 'startDate'
                        ? parseDate(todayDate)
                        : parseDate(maxDate)
                "
                :position="position"
                :disabled="disabled"
            >
                <template v-slot:trigger>
                    <b-button icon-left="calendar" type="is-primary" />
                </template>
                <div class="is-flex is-flex-centered">
                    <!-- <button class="btn save-btn calendar-btn is-flex is-flex-centered" @click="setYesterday()" :disabled="disableSetYesterday()" v-if="dateType=='startDate'">
                        <b-icon icon="calendar" class="mr-1" /> {{$t('ontem')}}
                    </button> -->
                    <button
                        class="btn save-btn calendar-btn is-flex is-flex-centered"
                        @click="setToday()"
                        v-if="
                            (endDate == null ||
                                !(dateType == 'startDate' && endDate < todayDate)) &&
                            showToday
                        "
                    >
                        <b-icon icon="calendar" class="mr-1" />
                        {{ $t('hoje') }}
                    </button>
                    <button
                        v-if="showClean"
                        class="btn delete-btn danger calendar-btn is-flex is-flex-centered ml-3"
                        @click="clearDate()"
                        :disabled="innerDate == null"
                    >
                        <b-icon icon="delete" class="mr-1" />
                        {{ $t('limpar') }}
                    </button>
                </div>
            </b-datepicker>
        </b-field>

        <span
            class="validation"
            v-text="getT(msg, '')"
            v-if="invalid && focusedOut && innerInvalidWhenDisabled"
        />
        <div class="clearfix" v-else-if="innerInvalidWhenDisabled && !noClearfix" />
    </div>
</template>

<script>
import VerifiedLable from '@/components/shared/VerifiedLable.vue';
import { mapState } from 'vuex';

export default {
    components: {
        VerifiedLable,
    },
    props: {
        /* 
        PROPS EXISTENTES:
        title, tooltip, dateType, value, startDate, endDate, placeholder, maxLength, yearsRange,
        subtractDateYears, subtractDateDays, subtractDateByDate, addDateDays, addDateYears, 
        invalid, msg, position, disabled, hideInfo, infoIsHidden, inForm, showClean, showToday, 
        id, disableMLtitle, tagnewid, required, tooltipLabel, tooltipPosition, tooltipType, 
        tooltipMultilined, tooltipSize, onBlur, onBlurFunction
        */

        title: {
            /* Títudo do datepicker */ type: String,
            default: 'data',
        },
        tooltip: {
            /* Caso tenha uma informação adicional sobre o campo */
            type: Boolean,
            default: false,
        },
        dateType: {
            type: String,
            default: 'default' /* 'default', 'startDate', 'endDate' */,
        },
        value: {
            /* Data selecionada */ type: Date,
            default: null,
        },
        startDate: {
            /* Data selecionada como data inicial, vai vir do componente pai caso selecionada a opção dateType:'endDate' */
            type: Date,
            default: null,
        },
        endDate: {
            /* Data selecionada como data final, vai vir do componente pai caso selecionada a opção dateType:'startDate'*/
            type: Date,
            default: null,
        },
        placeholder: {
            default: null,
            type: String,
        },
        maxLength: {
            /* Número máximo de caracteres */ type: Number,
            default: 10,
        },
        yearsRange: {
            /* Quantidade de anos antes e depois a aparecer no select */
            type: Array,
            default: () => [-20, 20],
        },
        subtractDateYears: {
            /* Anos a diminuir para controlar a data inicial */ type: Number,
            default: 30,
        },
        subtractDateDays: {
            /* Dias a diminuir para controlar a data inicial */ type: Number,
            default: 0,
        },
        subtractDateByDate: {
            /* diminuir por data para controlar a data inicial */ type: Date,
            default: null,
        },
        addDateDays: {
            /* Dias a aumentar para controlar a data final */ type: Number,
            default: 0,
        },
        addDateYears: {
            /* Anos a aumentar para controlar a data final */ type: Number,
            default: 0,
        },
        invalid: {
            /* Caso o campo seja obrigatório */ type: Boolean,
            default: false,
        },
        msg: {
            type: String,
            default: 'msg-campo-obrigatorio',
        },
        position: {
            type: String,
            default: 'is-bottom-left',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        invalidWhenDisabled: {
            type: Boolean,
            default: false,
        },
        hideInfo: {
            type: Boolean,
            default: false,
        },
        infoIsHidden: {
            type: Boolean,
            default: false,
        },
        // Ajusta tamanho para usar em formulários
        inForm: {
            type: Boolean,
            default: false,
        },
        // Esconde botão de limpar
        showClean: {
            type: Boolean,
            default: true,
        },
        // Esconde botão de setar hoje
        showToday: {
            type: Boolean,
            default: true,
        },
        id: {
            default: null,
        },
        disableMLtitle: {
            type: Boolean,
            default: false,
        },
        // Id do tagnew referente ao .env na raiz do sistema
        tagnewid: undefined,
        // O título fica com a cor primária da empresa e com um asterisco após o título
        required: {
            type: Boolean,
            default: false,
        },
        /* Caso tenha uma informação adicional sobre o campo */
        tooltipLabel: {
            type: String,
            default: null,
        },
        tooltipPosition: {
            type: String,
            default: 'is-right',
        },
        tooltipType: {
            type: String,
            default: 'is-dark',
        },
        tooltipMultilined: {
            type: Boolean,
            default: true,
        },
        tooltipSize: {
            type: String,
            default: 'is-large',
        },
        onBlur: {
            default: true,
            type: Boolean,
        },
        onFocus: {
            default: () => {},
            type: Function,
        },
        onBlurFunction: {
            default: () => {},
            type: Function,
        },
        disableMLplaceholder: {
            type: Boolean,
            default: false,
        },
        noClearfix: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            inputDate: null,
            innerDate: null,
            minDate: null,
            maxDate: null,
            // yesterdayDate: this.$moment().subtract(1, 'days'),
            todayDate: new Date(),
            dayNames: [
                this.$t('dom'),
                this.$t('seg'),
                this.$t('ter'),
                this.$t('qua'),
                this.$t('qui'),
                this.$t('sex'),
                this.$t('sab'),
            ],
            monthNameKeys: [
                'january',
                'february',
                'march',
                'april',
                'may',
                'june',
                'july',
                'august',
                'september',
                'october',
                'november',
                'december',
            ],
            monthNames: [],
            innerType: 'text',
            innerHideInfo: this.hideInfo,
            innerInfoIsHidden: this.infoIsHidden,
            focusedOut: false,
            debounceDate: null,
            innerInvalidWhenDisabled: false,
        };
    },
    mounted() {
        this.focusedOut = !this.onBlur;
    },
    watch: {
        subtractDateByDate() {
            this.minDate = this.$moment(this.subtractDateByDate).subtract(1, 'days');
        },
        value() {
            this.innerDate = this.value;
            this.inputDate = this.value != null ? this.$moment(this.value).format('L') : null;
        },
        hideInfo(val) {
            this.innerHideInfo = val;
        },
        infoIsHidden(val) {
            this.innerInfoIsHidden = val;
        },
        language(val) {
            this.setMonthNames();
        },
        endDate(val) {
            if(val != null) this.maxDate = new Date(val);
        },
        startDate(val) {
            if(val != null) this.minDate = new Date(val);
        },
    },
    computed: { ...mapState(['language']) },
    created() {
        this.innerInvalidWhenDisabled =
            !this.disabled || (this.invalidWhenDisabled && this.disabled);

        this.setMonthNames();
        this.innerDate = this.value;
        this.inputDate = this.innerDate != null ? this.$moment(this.innerDate).format('L') : null;
        if(this.startDate == null) {
            if (
                this.subtractDateByDate != null &&
                this.$moment(this.subtractDateByDate).format('YYYY-MM-DD') !=
                    this.$moment().format('YYYY-MM-DD')
            ) {
                this.minDate = this.$moment(this.subtractDateByDate).subtract(1, 'days');
            } else if (this.subtractDateDays == 0) {
                this.minDate = this.$moment().subtract(this.subtractDateYears, 'years').toDate();
            } else {
                this.minDate = this.$moment().subtract(this.subtractDateDays, 'days').toDate();
            }
        } else {
            this.minDate = new Date(this.startDate);
        }
        if(this.endDate == null) {
            if (this.addDateYears == 0) {
                this.maxDate = this.$moment().add(this.addDateDays, 'days').toDate();
            } else {
                this.maxDate = this.$moment().add(this.addDateYears, 'years').toDate();
            }
        } else {
            this.maxDate = new Date(this.endDate)
        }
    },
    methods: {
        setMonthNames() {
            this.monthNames = [];
            this.monthNameKeys.forEach((n) => {
                this.monthNames.push(this.$t(n));
            });
        },
        endDateMinusOne() {
            return this.parseDate(this.$moment(this.endDate).subtract(1, 'days'));
        },
        parseDate(date) {
            return this.$moment(date, 'DD/MM/YYYY').toDate();
        },
        updateDataInput(dateChanged) {
            clearTimeout(this.debounceDate);
            this.debounceDate = setTimeout(() => {
                if (dateChanged != null) {
                    if (dateChanged.length == 10 && this.parseDate(dateChanged)) {
                        this.innerDate = this.parseDate(dateChanged);
                    } else if (dateChanged.length == 0) {
                        this.clearDate();
                    } else if (dateChanged.length > 0 && dateChanged.length < 10) {
                        this.updateDate(dateChanged);
                    }
                }
            }, 500);
        },
        updateData(date) {
            setTimeout(() => {
                let message = null;
                if (this.$moment(date).isValid()) {
                    this.innerDate = date;
                    if (
                        this.dateType == 'startDate' &&
                        this.endDate != null &&
                        this.innerDate > this.endDate
                    ) {
                        message = 'data-maior-que-data-final';
                        this.sendNull();
                    } else if (
                        this.dateType == 'endDate' &&
                        this.startDate != null &&
                        this.innerDate < this.startDate
                    ) {
                        message = 'data-menor-que-data-inicial';
                        this.sendNull();
                    } else if (this.innerDate > this.maxDate) {
                        message = 'data-maior-que-data-limite';
                        this.sendNull();
                    } else if (this.innerDate < this.minDate) {
                        message = 'data-menor-que-data-limite';
                        this.sendNull();
                    } else {
                        this.inputDate = this.$moment(this.innerDate).format('L');
                        this.$emit('input', date);
                        this.$emit('onChange', date);
                    }
                } else {
                    if (this.dateType == 'startDate') message = 'msg-data-inicial-invalida';
                    else if (this.dateType == 'endDate') message = 'msg-data-final-invalida';
                    else message = 'msg-data-invalida';
                    this.sendNull();
                }
                if (message != null) {
                    this.$root.showMessage('alert', message);
                }
                setTimeout(() => {
                    if (this.dateType != 'default') this.$emit('carregarDados');
                }, 100);
            }, 500);
        },
        sendNull() {
            if (this.value == null) this.innerDate = null;
            // this.inputDate =
            //     this.innerDate != null
            //         ? this.$moment(this.innerDate).format("L")
            //         : null;
            //this.$emit("input", this.inputDate);
        },
        setToday() {
            this.loadData();
            this.inputDate = this.$moment(this.todayDate).format('L');
            this.$emit('input', this.todayDate);
        },
        // setYesterday() {
        //   this.$emit('input', this.yesterdayDate._d)
        //   this.loadData()
        // },
        // disableSetYesterday(){
        //   if(
        //     this.dateType=='startDate' &&
        //     this.endDate!=null &&
        //     this.yesterdayDate>this.endDate){
        //       return true
        //     }
        //     return false
        // },
        clearDate() {
            this.$emit('input', null);
            this.inputDate = null;
            this.innerDate = null;
        },
        updateDate(dateChanged) {
            this.innerDate = null;
            this.$emit('input', null);
            this.inputDate = dateChanged;
        },
        loadData() {
            this.blurEvt();

            if (this.dateType != 'default') this.$emit('carregarDados');
        },
        focusEvt() {
            this.focusedOut = false;

            if (this.onFocus) {
                this.onFocus();
            }
        },
        blurEvt() {
            let message = null;
            let currentDate = this.innerDate;
            if (this.$moment(this.innerDate).isValid()) {
                if (
                    this.dateType == 'startDate' &&
                    this.endDate != null &&
                    this.innerDate > this.endDate
                ) {
                    message = 'data-maior-que-data-final';
                    this.sendNull();
                } else if (
                    this.dateType == 'endDate' &&
                    this.startDate != null &&
                    this.innerDate < this.startDate
                ) {
                    message = 'data-menor-que-data-inicial';
                    this.sendNull();
                } else if (this.innerDate > this.maxDate) {
                    message = 'data-maior-que-data-limite';
                    this.sendNull();
                } else if (this.innerDate < this.minDate) {
                    message = 'data-menor-que-data-limite';
                    this.sendNull();
                } else {
                    this.inputDate = this.$moment(this.innerDate).format('L');
                    this.$emit('input', this.innerDate);
                    this.$emit('onChange', this.innerDate);
                }
            } else {
                if (this.dateType == 'startDate') message = 'msg-data-inicial-invalida';
                else if (this.dateType == 'endDate') message = 'msg-data-final-invalida';
                else message = 'msg-data-invalida';
                this.sendNull();
            }

            if (message != null && currentDate != null) {
                this.$root.showMessage('alert', message);
            }
            this.focusedOut = true;

            if (this.onBlur) {
                this.onBlurFunction();
            }
            // para quando quiser apenas saber se foi executado o blur
            this.$emit('onBlurFunction');
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep input::placeholder { font-family: "Montserrat", sans-serif; }
::v-deep input:-ms-input-placeholder { font-family: "Montserrat", sans-serif; }
::v-deep input::-ms-input-placeholder { font-family: "Montserrat", sans-serif; }

::v-deep .hidden-field > input {
    font-family: text-security-disc;
    -webkit-text-security: disc;
    color: $text-color;
}
</style>

<style lang="scss">
.height-form {
    .datapicker-input input {
        height: 36px !important;
    }
    .datapiker-button .dropdown button {
        height: 36px !important;
    }
}

.button-show-hide {
    height: 36px !important;
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    border-right: 0 !important;
}
.invalid-button-before {
    border-bottom-color: red;
    border-left-color: red;
    border-top-color: red;
}
.verified-datepicker {
    .invalid input {
        border-color: $red !important;
    }
    .calendar-btn {
        padding: 0;
        width: 100px;
        height: 35px;
    }
    .field.is-grouped > .control:not(:last-child) {
        margin-right: 0;
    }
    // .datepicker input{
    //   height: 40px !important;
    // }
    .datapicker-input input {
        border-radius: 2px 0 0 2px;
    }
    .input-hide input {
        border-top-left-radius: 0 !important;
        border-bottom-left-radius: 0 !important;
    }
    .datepicker .dropdown .dropdown-trigger button {
        border-radius: 0 2px 2px 0;
    }
    span.validation {
        font-size: 8px;
        color: $red;
        display: block;
        font-weight: 600;
    }
    .dropdown-menu {
        width: auto;
        padding: 0px 0px 0px;
    }
    .datepicker-header {
        margin: 0px 0px 5px;
        padding: 0px 0px 5px;
    }
    .datepicker-footer {
        margin: 5px 0px 0px;
        padding: 5px 0px 0px;
    }
    .is-unselectable {
        opacity: 0.5;
        cursor: default;
    }
    .pagination-previous,
    .pagination-next {
        min-width: 2.2em;
    }
    .pagination-previous {
        margin: 0 0.1rem 0.25rem 0;
    }
    .pagination-next {
        margin: 0 0 0.25rem 0.1rem;
    }
    .pagination-list {
        margin-bottom: 0.25rem;
        .field .control {
            font-size: 14px;
        }
    }
    .field:not(:last-child) {
        margin-bottom: 0;
    }
    .clearfix {
        height: 12px;
    }
}
</style>
